import React from 'react';
import {
  PostAdd,
  AssignmentOutlined,
  InboxOutlined,
  HelpOutlineOutlined,
  AssignmentTurnedInOutlined,
  PermContactCalendar,
  AssignmentInd,
  Face,
  Fingerprint,
  PanTool,
  Email,
  LibraryBooks,
} from '@material-ui/icons';
import IntlMessages from '../../../utils/IntlMessages';
import {
  administracion,
  analista,
  urgenciaV,
  mediaciones,
  fiscalizacion,
  seguimientoif,
  analistaFichaTecnica,
} from '../../../../routes/routesGroups';
import {
  Balance,
  HourglassBottom,
  /* RateReview, */ /* Send, */ SendTimeExtension,
  Gavel,
  DomainVerification,
} from '@mui/icons-material';
//import { getFichaTecnica } from 'services/api';

export const menuFichasTecnicasSinFicha = [
  {
    name: "inicio",
    type: 'item',
    icon: <AssignmentOutlined />,
    link: '/fichas_tecnicas',
  },
]

export const menuFichasTecnicas = [
  {
    name: 'Datos Generales de Identificación',
    type: 'collapse',
    icon: <AssignmentOutlined />,
    children: [
      {
        name: 'Identificación Prestador',
        type: 'item',
        icon: <AssignmentOutlined />,
        link: '/ft-identificacion-prestador',
      },
      {
        name: 'Acreditación',
        type: 'item',
        icon: <AssignmentOutlined />,
        link: '/ft-acreditacion',
      },
      {
        name: 'Representantes / Encargados(as)',
        type: 'item',
        icon: <AssignmentOutlined />,
        link: '/ft-representantes-encargados',
      },
    ],
  },

  {
    name: 'Capacidad Instalada',
    type: 'collapse',
    icon: <AssignmentOutlined />,
    children: [
      {
        name: 'Autorización Sanitaria',
        type: 'item',
        icon: <AssignmentOutlined />,
        link: '/ft-autorizacion-sanitaria',
      },
    ],
  },
  {
    name: "Dotación Personal",
    type: 'item',
    icon: <AssignmentOutlined />,
    link: '/ft-dotacion-personal',
  },
  {
    name: "Equipamiento",
    type: 'item',
    icon: <AssignmentOutlined />,
    link: '/ft-equipamiento',
  },
];

const menuAnalistaExtranet = [
  {
    name: <IntlMessages id={'pages.analista.asignaciones'} />,
    type: 'item',
    icon: <AssignmentOutlined />,
    link: '/asignaciones',
  },
  /*   {
    name: <IntlMessages id={'pages.analista.reclamos'} />,
    type: 'item',
    icon: <RateReview />,
    link: '/reclamos',
  }, */
  {
    name: <IntlMessages id={'pages.analista.pendientes'} />,
    type: 'item',
    icon: <HourglassBottom />,
    link: '/pendientes',
  },
  {
    name: <IntlMessages id={'pages.analista.derivaciones'} />,
    type: 'item',
    icon: <SendTimeExtension />,
    link: '/derivaciones',
  },
  {
    name: 'Todos los reclamos',
    type: 'item',
    icon: <DomainVerification />,
    link: '/gestionados',
  },
  {
    name: <IntlMessages id={'pages.analista.ayuda'} />,
    type: 'item',
    icon: <HelpOutlineOutlined />,
    link: '/ayuda',
  },
];

const menuAnalistaSeguimientoIf = [
  {
    name: <IntlMessages id={'pages.analista.asignaciones'} />,
    type: 'item',
    icon: <AssignmentOutlined />,
    link: '/seguimientoif/asignaciones',
  },

  {
    name: 'Todos los Reclamos',
    type: 'item',
    icon: <LibraryBooks />,
    link: '/seguimientoif/todos',
  },
  {
    name: <IntlMessages id={'pages.analista.derivaciones'} />,
    type: 'item',
    icon: <SendTimeExtension />,
    link: '/seguimientoif/derivaciones',
  },
  {
    name: 'Mediación',
    type: 'item',
    icon: <Gavel />,
    link: '/seguimientoif/mediacion',
  },
  {
    name: 'Reclamos',
    type: 'item',
    icon: <PanTool />,
    link: '/seguimientoif/reclamos',
  },
  {
    name: 'Arbitraje',
    type: 'item',
    icon: <Balance />,
    link: '/seguimientoif/arbitraje',
  },
  {
    name: 'Correos de Notificación',
    type: 'item',
    icon: <Email />,
    link: '/seguimientoif/correos',
  },
  {
    name: <IntlMessages id={'pages.analista.ayuda'} />,
    type: 'item',
    icon: <HelpOutlineOutlined />,
    link: '/seguimientoif/ayuda',
  },
];

const menuAdmExtranet = [
  {
    name: <IntlMessages id={'pages.usuarios'} />,
    type: 'item',
    icon: <PostAdd />,
    link: '/usuarios',
  },
];

const menuUrgenciaVital = [
  {
    name: <IntlMessages id={'pages.urgenciaVita.por.confirmar'} />,
    type: 'item',
    icon: <AssignmentInd />,
    link: '/urgencia-vital',
  },

  {
    name: <IntlMessages id={'pages.urgenciaVital.persona.fecha'} />,
    type: 'item',
    icon: <PermContactCalendar />,
    link: '/urgencia-vital-fecha',
  },

  {
    name: <IntlMessages id={'pages.urgenciaVital.persona.rut'} />,
    type: 'item',
    icon: <Fingerprint />,
    link: '/urgencia-vital-rut',
  },

  {
    name: <IntlMessages id={'pages.urgenciaVital.persona.nombre'} />,
    type: 'item',
    icon: <Face />,
    link: '/urgencia-vital-nombre',
  },

  {
    name: <IntlMessages id={'pages.urgenciaVital.personas.ricarte'} />,
    type: 'item',
    icon: <Gavel />,
    link: '/urgencia-vital-ricarte',
  },
];

const menuMediaciones = [
  /*   {
    name: <IntlMessages id={'pages.mediaciones.ejemplo'} />,
    type: 'item',
    icon: <PostAdd />,
    link: '/mediaciones',
  }, */
  {
    name: <IntlMessages id={'pages.analista.asignaciones'} />,
    type: 'item',
    icon: <AssignmentOutlined />,
    link: '/mediaciones',
  },
  {
    name: <IntlMessages id={'pages.analista.mediaciones'} />,
    type: 'item',
    icon: <InboxOutlined />,
    link: '/mediacionesReclamos',
  },
  {
    name: <IntlMessages id={'pages.analista.pendientes'} />,
    type: 'item',
    icon: <InboxOutlined />,
    link: '/mediacionesPendientes',
  },
  // {
  //   name: <IntlMessages id={'pages.analista.buscador'} />,
  //   type: 'item',
  //   icon: <PostAdd />,
  //   link: '/buscador',
  // },
  {
    name: <IntlMessages id={'pages.analista.ayuda'} />,
    type: 'item',
    icon: <HelpOutlineOutlined />,
    link: '/mediacionesAyuda',
  },
];

const menuFiscalizacion = [
  {
    name: <IntlMessages id={'pages.fiscalizacion.ejemplo'} />,
    type: 'item',
    icon: <AssignmentTurnedInOutlined />,
    link: '/fiscalizacion',
  },
];

const dynamicMenu = (user, location, type) => {
  var menu = [];

  if (administracion.includes(location)) {
    menu.push({
      name: 'Administración',
      type: type,
      children: menuAdmExtranet,
    });
  } /* else if (analista.includes(location)) {
    if (location === '/fichas_tecnicas') {
      menu.push({
        name: 'Analista',
        type: type,
        children: menuFichasTecnicas,
      });
    } else {
      menu.push({
        name: 'Analista',
        type: type,
        children: menuAnalistaExtranet,
      });
    }
  } */
  else if (analista.includes(location)) {
    menu.push({
      name: 'Analista',
      type: type,
      children: menuAnalistaExtranet,
    });

  }
  else if (analistaFichaTecnica.includes(location)) {

    menu.push({
      name: 'Analista',
      type: type,
      children: menuFichasTecnicas,
    });

  }
  else if (urgenciaV.includes(location)) {
    menu.push({
      name: 'UrgenciaV',
      type: type,
      children: menuUrgenciaVital,
    });
  } else if (mediaciones.includes(location)) {
    menu.push({
      name: 'Mediaciones',
      type: type,
      children: menuMediaciones,
    });
  } else if (fiscalizacion.includes(location)) {
    menu.push({
      name: 'Fiscalización',
      type: type,
      children: menuFiscalizacion,
    });
  } else if (seguimientoif.includes(location)) {
    menu.push({
      name: 'Analista',
      type: type,
      children: menuAnalistaSeguimientoIf,
    });
  }

  return menu;
};

const dynamicMenuCollapse = (user, location) => {
  return dynamicMenu(user, location, 'collapse');
};

const dynamicMenuSection = (user, location) => {
  return dynamicMenu(user, location, 'section');
};

export const menusCollapse = dynamicMenuCollapse;

export const menusSection = dynamicMenuSection;
